import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, DollarSign, Mic, RefreshCw, Bookmark, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent } from './ui/card';
import { Separator } from './ui/separator';
import Header from './Header';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LandingPage = () => {
  const [email, setEmail] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [loadingFaqs, setLoadingFaqs] = useState(true);
  const navigate = useNavigate();

  // Fetch FAQs from backend
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch(`${API_URL}/api/faq`);
        if (response.ok) {
          const data = await response.json();
          setFaqs(data.faqs || []);
        }
      } catch (error) {
        console.error('Failed to fetch FAQs:', error);
      } finally {
        setLoadingFaqs(false);
      }
    };
    fetchFaqs();
  }, []);

  const handleGetStarted = () => {
    navigate('/login', { state: { email } });
  };

  const features = [
    {
      icon: <DollarSign className="w-10 h-10" />,
      iconColor: "text-yellow-400",
      title: "Control your content",
      description: "Watch on Smart TVs, Playstation, using commission control u choose much much each one of your referrals get. Also direct sales"
    },
    {
      icon: <Mic className="w-10 h-10" />,
      iconColor: "text-cyan-400",
      title: "Free networking, free to watch",
      description: "direct messages on an off line, live video chat in app, free an paid plans.updates"
    },
    {
      icon: <RefreshCw className="w-10 h-10" />,
      iconColor: "text-yellow-500",
      title: "Hyper flow",
      description: "share on all social media platforms, an also upload content not making making money. Also replace profile icon that represents Hyperflow"
    },
    {
      icon: <Bookmark className="w-10 h-10" />,
      iconColor: "text-purple-400",
      title: "Save your favorites",
      description: "Save your favorites easily and always have something to watch."
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Header isLandingPage={true} />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-black"
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 max-w-4xl mx-auto leading-tight">
            Unlimited commission, video & music uploads, and more
          </h1>
          <p className="text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            one time payment of $30 for the year, controlled commissions, Hyperflow commissions, unlimited posting, video chat session. Join the Agency in the Agencies of the future
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
            <Input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-black/70 border-gray-400 text-white placeholder:text-gray-400 h-14 text-lg"
            />
            <Button
              onClick={handleGetStarted}
              className="bg-gradient-to-r from-yellow-400 to-purple-500 hover:from-yellow-500 hover:to-purple-600 text-white h-14 px-8 text-lg font-semibold"
            >
              Get Paid <ChevronRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {features.map((feature) => (
              <Card key={feature.title} className="bg-gray-900/80 border-gray-700 rounded-xl overflow-hidden">
                <CardContent className="p-8 text-center">
                  <div className={`${feature.iconColor} mb-4 flex justify-center`}>
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-white">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Separator className="bg-gray-800" />

      {/* FAQ Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto space-y-4">
            {loadingFaqs ? (
              <div className="flex justify-center py-12">
                <Loader2 className="w-8 h-8 animate-spin text-yellow-400" />
              </div>
            ) : faqs.length === 0 ? (
              <p className="text-center text-gray-400">No FAQs available</p>
            ) : (
              faqs.map((faq, index) => (
                <Card key={faq.id || index} className="bg-gray-900 border-gray-700">
                  <CardContent className="p-6">
                    <h3 className="text-xl font-medium mb-2 text-white">
                      {faq.question}
                    </h3>
                    <p className="text-gray-400">
                      {faq.answer}
                    </p>
                  </CardContent>
                </Card>
              ))
            )}
          </div>
          
          <div className="text-center mt-12">
            <p className="text-lg mb-6">
              Ready to watch? Enter your email to create or restart your membership.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
              <Input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-black/70 border-gray-400 text-white placeholder:text-gray-400 h-14 text-lg"
              />
              <Button
                onClick={handleGetStarted}
                className="bg-gradient-to-r from-yellow-400 to-purple-500 hover:from-yellow-500 hover:to-purple-600 text-white h-14 px-8 text-lg font-semibold"
              >
                Get Paid <ChevronRight className="w-5 h-5 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-16 border-t border-gray-800">
        <div className="container mx-auto px-4">
          {/* Tagline Section */}
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-3xl font-bold tracking-wider text-white mb-2">
              KINGS NEED THRONES NOT PLATFORMS
            </h3>
            <p className="text-lg tracking-wide text-gray-400">
              PREMIUM BLACK MARKETING AN TELEVISION
            </p>
          </div>
          
          <Separator className="bg-gray-800 my-8" />
          
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-medium mb-4 text-gray-400">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">About Us</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Jobs</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Press</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium mb-4 text-gray-400">Support</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Help Center</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Contact Us</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Legal</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium mb-4 text-gray-400">Account</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Manage Account</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Privacy</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Terms</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium mb-4 text-gray-400">Social</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Facebook</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Twitter</a></li>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors">Instagram</a></li>
              </ul>
            </div>
          </div>
          
          <Separator className="bg-gray-800 my-8" />
          
          <div className="text-center text-gray-500 text-sm">
            <p>&copy; 2024 I Got Soul. Premium Black Entertainment Platform.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;